import { render } from "./3dGame.vue?vue&type=template&id=19fd9326&scoped=true"
import script from "./3dGame.vue?vue&type=script&lang=js"
export * from "./3dGame.vue?vue&type=script&lang=js"

import "./3dGame.vue?vue&type=style&index=0&id=19fd9326&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fd9326"]])

export default __exports__